module.exports = {"230421100":"凤翔镇","230421101":"鹤北镇","230421102":"名山镇","230421103":"团结镇","230421104":"肇兴镇","230421105":"云山镇","230421200":"东明朝鲜族乡","230421203":"太平沟乡","230421400":"萝北县林业局","230421401":"鹤北林业局","230421500":"宝泉岭管理局局直","230421501":"江滨农场","230421502":"军川农场","230421503":"名山农场","230421504":"延军农场","230421505":"共青农场","230421506":"宝泉岭农场","230421580":"萝北县农业局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230421.json
// module id = 810
// module chunks = 0